<template>
  <div>
    <div id="header">
      <router-link
        to="/driver/Center"
        v-if="isdriver"
      >
        <div class="tosijibtn">切换司机版<img
            src="../assets/images/getinto.png"
            style="width:0.2rem;height:0.25rem;margin-left:0.05rem; vertical-align: middle;"
          ></div>
      </router-link>
    </div>
    <div id="main">
      <div id="user-content">
        <yd-grids-group
          :rows="3"
          item-height="2.15rem"
        >
          <yd-grids-item style="text-align:left; width:1.5rem;">
            <div slot="else">
              <img
                id="headimg"
                :src="userinfo.headimg"
              >
            </div>
          </yd-grids-item>
          <yd-grids-item style="text-align:left; width:2.9rem;">
            <div slot="else">
              <div style="font-size:0.34rem;color:#333333;">{{userinfo.username}}</div>
              <div
                style="font-size:0.25rem;color:#999999;"
                @click="showUpdmobile()"
              >手机：{{userinfo.mobile}}</div>
            </div>
          </yd-grids-item>
          <yd-grids-item style="text-align:right; width:2.1rem;">
            <div slot="else">
              <div style="font-size:0.28rem;color:black;text-align:left">累计<span style="font-size:0.36rem;color:#0480e8;font-weight:bold;"> {{userinfo.credit}} </span>积分</div>
              <router-link
                to="/shop"
                style="text-align:center"
              >
                <span style="font-size:0.28rem;color:#666;">积分商城</span>
                <span><img
                    src="../assets/images/getinto.png"
                    style="width:0.2rem;height:0.25rem;margin-left:0.05rem; vertical-align: middle;"
                  ></span>
              </router-link>

            </div>
          </yd-grids-item>
        </yd-grids-group>
      </div>
    </div>
    <!-- <div style="margin-top:0.2rem;  border-bottom: 1px solid #EEEEEE;"></div> -->
    <yd-popup
      v-model="updshow"
      position="center"
      width="90%"
      masker-opacity=".9"
    >
      <div style="background-color:#fff; padding:0.3rem;">
        <yd-cell-group>
          <yd-cell-item>
            <span slot="left">手机号：</span>
            <yd-input
              slot="right"
              type="number"
              required
              v-model="userinfo.mobile"
              regex="mobile"
              placeholder="请输入联系手机号码"
            ></yd-input>
          </yd-cell-item>
        </yd-cell-group>
        <p style="text-align: center;">
          <yd-button
            @click.native="updMobile()"
            id="sub-btn"
          >立即修改</yd-button>
        </p>
      </div>
    </yd-popup>
  </div>
</template>

<script>
export default {
  name: "Uheader",

  props: {},
  data() {
    return {
      userinfo: JSON.parse(JSON.stringify(this.$store.getters.getUserinfo)),
      updshow: false,
      isdriver: false
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.isDriver();
	this.getUserinfo();
  },
  watch: {},
  methods: {
    showUpdmobile() {
      this.updshow = true;
    },
    updMobile() {
      this.$ajax({
        method: "post",
        url: "Ucenter/updMobile",
        data: { id: this.userinfo.id, mobile: this.userinfo.mobile }
      })
        .then(response => {
          if (response.data.errno == 0) {
            this.$dialog.toast({
              mes: response.data.errmsg,
              timeout: 1500,
              icon: "success"
            });
            this.updshow = false;
            this.$store.commit("setMobile", this.userinfo.mobile);
          } else {
            console.log("错误:" + response.data.errmsg);
            this.$dialog.toast({
              mes: response.data.errmsg,
              timeout: 1500,
              icon: "error"
            });
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    isDriver: function() {
      this.$ajax({
        method: "post",
        url: "Dcenter/is_driver",
        data: {}
      })
        .then(response => {
          if (response.data.errno == 0) {
            this.isdriver = true;
          } else {
            this.isdriver = false;
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
	getUserinfo: function() {
		var that = this;
		this.$ajax({
				method: "post",
				url: "ucenter/index",
				data: {
	
				}
			})
			.then(response => {
				if (response.data.errno == 0) {
					this.userinfo = response.data.data;
				}
			})
			.catch(function(err) {
				that.norecord.isonload = true;
				console.log(err);
			});
	}
  },
  components: {}
};
</script>

<style scoped lang="css">
#header {
  width: 100%;
  height: 2.42rem;
  background-image: url("../assets/images/bg.png");
  background-repeat: no-repeat;
  background-size: 100%;
  padding: 0.48rem 0.3rem 0 0.3rem;
  background-position-y: -1.5rem;
}
#main {
  width: 100%;
  height: auto;
  padding: 0 0.3rem;
  margin-top: -1rem;
}
#user-content {
  background-color: #ffffff;
  height: 2.15rem;
  width: 6.9rem;
  border-radius: 0.5%;
  padding: 0 0.2rem;
  box-shadow: 0 2px 5px #ccc;
}
#user-content #headimg {
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 0.7rem;
  box-shadow: 0px 0px 1px 0px #ccc;
}

.yd-grids-3:before {
  background-image: none !important;
}
.yd-grids-3 .yd-grids-item:not(:nth-child(3n)):before {
  background-image: none !important;
}
.yd-grids-item:after {
  background-image: none !important;
}
.tosijibtn {
  color: #fff;
  right: 0.3rem;
  top: 0.4rem;
  position: absolute;
  font-size: 0.3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Uheader.vue